export const ItemMasterEndpoint = {
  item: "item",
  masterCourseList: "item/item/master/course",
  levelDetails: "item/master/courseLevel",
  exportExcel: "item/export/excel",
};
